import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { guestGuard } from './core/guards/guest.guard';
import { authGuard } from './core/guards/auth.guard';
import { dashboardsViewGuard } from './core/guards/dashboards-view.guard';

const translatedTitle = (key: string) => () => inject(TranslocoService).selectTranslate(key);

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/landing-page/landing-page').then((c) => c.LandingPage),
    title: translatedTitle('routes.home'),
    canActivate: [guestGuard],
  },

  {
    path: 'login',
    loadComponent: () => import('./features/auth/pages/login/login').then((c) => c.Login),
    title: translatedTitle('routes.login'),
    canActivate: [guestGuard],
  },

  {
    path: 'register',
    loadComponent: () => import('./features/auth/pages/register/register').then((c) => c.Register),
    title: translatedTitle('routes.register'),
    canActivate: [guestGuard],
  },

  {
    path: 'reset-password',
    loadComponent: () => import('./features/auth/pages/reset-password/reset-password').then((c) => c.ResetPassword),
    title: translatedTitle('routes.resetPassword'),
    canActivate: [guestGuard],
  },

  {
    path: 'confirm-email',
    loadComponent: () => import('./features/auth/pages/confirm-email/confirm-email').then((c) => c.ConfirmEmail),
    title: translatedTitle('routes.confirmEmail'),
    canActivate: [guestGuard],
  },

  {
    path: 'projects',
    loadChildren: () => import('./features/projects/projects.routes').then((r) => r.projectsRoutes),
  },
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then((r) => r.adminRoutes),
  },
  {
    path: 'platform-data',
    loadComponent: () => import('./features/admin/pages/platform-data/platform-data').then((c) => c.PlatformData),
    canActivate: [authGuard, dashboardsViewGuard],
    title: translatedTitle('routes.platformData'),
  },
  {
    path: 'referral',
    loadChildren: () => import('./features/referral/referral.routes').then((r) => r.referralRoutes),
  },

  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
